import LocalStorageRepository from '@/domain/repository/LocalStorageRepository';
import {decodeJwt, isTokenExpired} from '@/domain/services/jwt';
import authRepository from '@/domain/repository/AuthRepository';


export const refreshToken = async () => {

  const {access, refresh} = LocalStorageRepository.getCredentials();

  if (refresh === undefined) {
    return {
      access: undefined,
      refresh: undefined,
    };
  }

  const accessToken = access ? decodeJwt(access) : undefined;
  const refreshToken = refresh ? decodeJwt(refresh) : undefined;

  if (accessToken && !isTokenExpired(accessToken, 30)) {
    return {access, refresh};
  } else if (!isTokenExpired(refreshToken, 30)) {
    try {
      const response = await authRepository.refresh({refresh});

      LocalStorageRepository.setCredentials({
        access: response.access
      });

      return {
        access: response.access,
        refresh: refresh,
      };
    } catch (error) {
      console.error(error);
    }
  }

  return {
    access: undefined,
    refresh: undefined,
  };
};

export const isAuthenticated = async (): Promise<boolean> => {
  const {access, refresh} = await refreshToken();
  return access !== undefined && refresh !== undefined;
};